import { Component, OnInit, Input } from '@angular/core';
import { CaseBankDetailsService } from '../../../shared/services/case-bank-details.service';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {

   @Input() caseId: number = -1;

  bankDetails = this.fb.group({
    id: null,
    nameOnCard: '',
    bankName: '',
    accountNumber: '',
    sortCode: ''
  }, { });

  constructor(public activeModal: NgbActiveModal,
              private caseBankDetailsService: CaseBankDetailsService,
              private fb: UntypedFormBuilder) {
    
  }

  ngOnInit(): void {
    this.loadDetails();
  }

  loadDetails(){
    this.caseBankDetailsService.getBankDetails( this.caseId ).subscribe((response : any) => {
      this.bankDetails.patchValue(response.bankDetails);
    });
  }

  updateField(){

    this.caseBankDetailsService.updateBankDetails(this.caseId, this.bankDetails.value).subscribe((response : any) => {

    }, (error : any) => {


    });
  }
}
